<template>
  <b-modal
    id="delete-modal"
    title="Confirm Delete"
    ref="DeleteMultipleProduct"
    hide-footer
    hide-header
    hide-backdrop
    :no-close-on-backdrop="true"
    size="lg"
  >
    <b-row>
      <b-col sm="1">
        <p class="text-left mt-4 pr-5">
          <img
            src="@/assets/images/warning.svg"
            alt="warning icon"
            width="60"
            height="60"
            id="warning-icon"
          />
        </p>
      </b-col>
      <b-col sm="7">
        <div class="mx-auto text-left delete-message">
          {{ deletePromptMessage }}
        </div>
      </b-col>
      <b-col sm="4">
        <div class="d-sm-inline-flex p-2">
          <b-button
            size="sm"
            id="cancel-btn"
            style="
              background-color: transparent;
              border-color: transparent;
              color: #989899;
            "
            :disabled="loading"
            @click="closeModal()"
            >Cancel</b-button
          >
          &nbsp;
          <b-button
            size="sm"
            id="delete-btn"
            style="background-color: #1a73e8; border-color: #1a73e8"
            :disabled="loading"
            @click="deleteProducts()"
            >Yes, Delete</b-button
          >
        </div>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "ConfirmDeleteMultipleProducts",
  props: ["status", "product_ids", "merchant_uuid"],
  computed: {
    ...mapState("estoreInventories", [
      "loading",
      "errors",
      "modal",
      "taggedProducts",
    ]),

    deletePromptMessage() {
      if (this.modal.delete_multiple_products.has_tagged_products == 1) {
        return "Some products are currently tagged to a brand and branch. Are you sure you want to delete all the selected products? This action cannot be undone.";
      } else {
        return "Are you sure you want to delete all the selected products? This action cannot be undone.";
      }
    },
  },
  methods: {
    closeModal: function () {
      this.$store.commit("estoreInventories/setModal", {
        type: "delete_multiple_products",
        status: false,
        product_ids: this.product_ids,
        merchant_uuid: this.merchant_uuid,
        has_tagged_products:
          this.modal.delete_multiple_products.has_tagged_products,
      });
    },

    deleteProducts: async function () {
      let param = {
        product_ids: this.product_ids,
        merchant_uuid: this.merchant_uuid,
      };

      await this.$store
        .dispatch("estoreInventories/deleteMultipleProduct", param)
        .then(() => {
          if (this.errors == null) {
            this.$store.commit("estoreInventories/setModal", {
              type: "delete_multiple_products",
              status: false,
              product_ids: [],
              merchant_uuid: "",
              has_tagged_products: 0,
            });

            this.$store.dispatch("estoreInventories/getProducts", {
              page: 1,
              payload: {
                filters: {
                  paired_key: "all",
                  keyword: "",
                  column: "all",
                },
              },
            });

            this.$root.$emit("onMultipleDelete");
          }
        });
    },
  },
  watch: {
    status: function (status) {
      if (status == true) {
        this.$refs.DeleteMultipleProduct.show();
      } else {
        this.$refs.DeleteMultipleProduct.hide();
      }
    },
  },
};
</script>

<style>
#cancel-btn {
  background-color: transparent !important;
  border-color: transparent !important;
  color: #989899 !important;
}

#delete-btn {
  background-color: #1a73e8 !important;
  border-color: #1a73e8 !important;
  font-size: 11pt;
}

div#delete-modal {
  background: transparent !important;
}

@media (min-width: 320px) {
  div#delete-modal___BV_modal_content_ {
    position: absolute !important;
    top: 200px !important;
    left: 60px !important;
    width: 210px !important;
  }
  img#warning-icon {
    position: absolute !important;
    top: 2px !important;
    left: 50px !important;
    height: 30pt;
    width: 30pt;
  }
  div.delete-message {
    font-size: 10pt;
    text-align: center !important;
    padding-top: 20px !important;
  }
  #cancel-btn,
  #delete-btn {
    margin-left: 20px;
    margin-top: 15px !important;
    font-size: 7pt;
  }
}

@media (min-width: 375px) {
  div#delete-modal___BV_modal_content_ {
    position: absolute !important;
    top: 200px !important;
    left: 40px !important;
    width: 300px !important;
  }
  img#warning-icon {
    position: absolute !important;
    top: 2px !important;
    left: 90px !important;
    height: 30pt;
    width: 30pt;
  }
  div.delete-message {
    font-size: 10pt;
    text-align: center !important;
    padding-top: 20px !important;
  }
  #cancel-btn,
  #delete-btn {
    margin-left: 20px;
    margin-top: 15px !important;
    font-size: 7pt;
  }
}

@media (min-width: 425px) {
  div#delete-modal___BV_modal_content_ {
    position: absolute !important;
    top: 200px !important;
    left: 80px !important;
    width: 300px !important;
  }
  img#warning-icon {
    position: absolute !important;
    top: 2px !important;
    left: 90px !important;
    height: 30pt;
    width: 30pt;
  }
  div.delete-message {
    font-size: 10pt;
    text-align: center !important;
    padding-top: 20px !important;
  }
  #cancel-btn,
  #delete-btn {
    margin-left: 20px;
    margin-top: 15px !important;
    font-size: 7pt;
  }
}

@media (min-width: 576px) {
  div#delete-modal___BV_modal_content_ {
    position: absolute !important;
    top: 200px !important;
    left: 50px !important;
    width: 450px !important;
  }
  img#warning-icon {
    position: absolute !important;
    top: 20px !important;
    left: -20px !important;
    height: 30pt;
    width: 30pt;
  }
  div.delete-message {
    font-size: 9pt;
    text-align: left !important;
  }
  #cancel-btn,
  #delete-btn {
    margin-left: -5px;
    margin-top: 25px !important;
    font-size: 7pt;
    width: 65px;
  }
}

@media (min-width: 768px) {
  div#delete-modal___BV_modal_content_ {
    position: absolute !important;
    top: 350px !important;
    left: -44px !important;
    width: 500px !important;
  }
  img#warning-icon {
    position: absolute !important;
    top: 20px !important;
    left: -15px !important;
  }
  div.delete-message {
    text-align: left !important;
  }
  #cancel-btn,
  #delete-btn {
    width: 70px !important;
    margin-left: -5px !important;
  }
}

@media (min-width: 1024px) {
  div#delete-modal___BV_modal_content_ {
    position: absolute !important;
    top: 540px !important;
    left: 55px !important;
    width: 680px !important;
  }
  img#warning-icon {
    position: absolute !important;
    top: 20px !important;
    left: 5px !important;
  }
  div.delete-message {
    text-align: left !important;
  }
}

@media (min-width: 1280px) {
  div#delete-modal___BV_modal_content_ {
    position: absolute !important;
    top: 450px !important;
    left: -75px !important;
    width: 630px !important;
  }
  img#warning-icon {
    position: absolute !important;
    top: 20px !important;
    left: -10px !important;
  }
  #cancel-btn,
  #delete-btn {
    width: 70px !important;
    margin-left: -5px !important;
  }
}

@media (min-width: 1400px) {
  div#delete-modal___BV_modal_content_ {
    position: absolute !important;
    top: 550px !important;
    left: -155px !important;
    width: 650px !important;
  }
  img#warning-icon {
    position: absolute !important;
    top: 18px !important;
    left: -10px !important;
  }
}
</style>
